<template>
  <div class="main-footer no-print">
    <!-- <div class="atualizacoes-its" v-if="getITData.length > 0">
      <TituloLateral titulo="ATUALIZAÇÕES DE IT'S" :temBotao="false"/>
      <it-loading v-if="carregando" />
      <ul>
        <li v-for="(it, indice) in getITData" :key="indice">
          <img src="@/assets/imgs/icone_download.svg" class="icone-download">
          <a :href="it.arquivo" target="_blank">{{it.titulo | uppercase }}</a>
        </li>
      </ul>
    </div>-->
    <div class="copyright-before">
      <span>
        Copyright © <span>{{ currentYear }}</span>. Todos os direitos reservados
      </span>
      <a href="https://www.before.com.br/" target="_blank" title="Clique aqui e conheça mais sobre a empresa Before">
        <img src="@/assets/imgs/logo-before-laranja.png" alt="Logotipo Before TI">
      </a> 
    </div>
    <div class="footer-baixo">
      <img src="@/assets/imgs/rodape.png" class="pattern-rodape" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import env from '../../../config/env';
// import FooterITLoading from '@/components/Loading/FooterITLoading';

export default {
  name: 'MainFooter',
  components: {
    // 'it-loading': FooterITLoading,
  },
  computed: {
    ...mapGetters('it', ['carregando', 'getITData']),
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.main-footer {
  user-select: none;
  // & .atualizacoes-its {
  //   @extend %flex;
  //   @extend %direction-column;
  //   flex: 0.48;

  //   & ul {
  //     margin: 0px;
  //     padding: 0px;
  //     margin-top: 10px;

  //     & li {
  //       padding: 4px 0px;

  //       & img {
  //         margin-bottom: -2px;
  //       }

  //       & a {
  //         margin: 0px;
  //         font-family: "Officina";
  //         font-style: italic;
  //         font-size: 16px;
  //         color: $cor_cinza_100;
  //         padding-left: 10px;
  //         text-decoration: none;
  //       }
  //     }
  //   }
  // }
  & .copyright-before {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    color: #665d6a;
    font-size: 0.9rem;
    font-style: italic;
    margin-top: 20px;
    
    a img {
      width: 60px;
      cursor: pointer;
    }
  }

  & .footer-baixo {
    max-width: 100%;

    & .pattern-rodape {
      max-width: 100%;
      margin-bottom: -80px;
    }
  }
}

@keyframes grow {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  .main-footer {
    .footer-baixo {
      display: flex;
      align-items: flex-end;

      & .pattern-rodape {
        object-fit: none;
        margin-bottom: 0px;
      }
    }
  }
}
</style>
